// extracted by mini-css-extract-plugin
module.exports = {"toggle":"PaymentType_toggle__1UFWr","option":"PaymentType_option__OHvLT","discount":"PaymentType_discount__1y7T5"};